import React, { useState } from "react";

function ScrollTop() {
  const [visible, setVisible] = useState(false);
  const toggleVisible = () => {
    const scrolled = document.documentElement.scrollTop;
    if (scrolled > 300) {
      setVisible(true);
    } else if (scrolled <= 300) {
      setVisible(false);
    }
  };
  window.addEventListener("scroll", toggleVisible);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <div
      className="scroll-top-wrap"
      onClick={scrollToTop}
      style={{ display: visible ? "flex" : "none" }}
      title={"Nazad na vrh".translate()}
    >
      <div className="scroll-top-inner">
        <i className="bi bi-caret-up-fill"></i>
      </div>
    </div>
  );
}

export default ScrollTop;
